import {
  type Employment,
  EmploymentStatus,
  EmploymentType,
  type GetEmploymentsResponse,
} from '@omnipresentgroup/types';

import { DEFAULT_LEGAL_ENTITY } from '../legalEntities';
import { DEFAULT_EMPLOYEE_USER } from '../users';

export const DEFAULT_EMPLOYMENT: Employment = {
  id: 'f5e5f1f1-71cc-42f6-8d0c-3b60d37fd391',
  userId: DEFAULT_EMPLOYEE_USER.userId,
  type: EmploymentType.EOR,
  // eslint-disable-next-line no-magic-numbers
  companyId: DEFAULT_EMPLOYEE_USER.roles[0].tenantId,
  lspId: 'of1WbA9Hc2OP',
  lspName: 'OmniPresent',
  status: EmploymentStatus.ACTIVE,
  startDate: '2024-03-03',
  firstPayrollDate: '2024-03-29',
  createdAt: '2023-03-03T09:41:05.427Z',
  lastUpdatedAt: '2023-03-03T09:41:05.427Z',
  legalEntityId: DEFAULT_LEGAL_ENTITY.id,
};

export const generateEmployment = (override: Partial<Employment> = {}) => ({
  ...DEFAULT_EMPLOYMENT,
  ...override,
});

export const DEFAULT_EMPLOYMENTS_RESPONSE: GetEmploymentsResponse = [
  DEFAULT_EMPLOYMENT,
  generateEmployment({
    id: '76881775-41e3-46f5-9e07-d33f87058ead',
    status: EmploymentStatus.INACTIVE,
    terminationDate: '2025-03-03',
    lastPayrollDate: '2025-03-29',
    createdAt: '2023-03-03T09:41:05.427Z',
    lastUpdatedAt: '2023-03-03T09:41:05.427Z',
  }),
  generateEmployment({
    id: '14f1edea-0a6b-4443-9131-f681312c9e98',
    status: EmploymentStatus.ONBOARDED,
    startDate: '2026-03-03',
    firstPayrollDate: '2026-03-29',
    createdAt: '2024-03-03T09:41:05.427Z',
  }),
];
